import './App.scss';
import Header from '../Header/Header';
import Form from '../Form/Form';
import Footer from '../Footer/Footer';
import mainImage from '../assets/images/cole-ribera-min.png';
import captionOne from '../assets/images/captions/caption-1-min.jpg';
import captionTwo from '../assets/images/captions/caption-2-min.jpg';
import captionThree from '../assets/images/captions/caption-3-min.jpg';
import wineGlass from '../assets/images/splash-1-min-2.png';

function App() {
  return (
    <div className="App">

      <Header></Header>

      <div className="content__container">
        <div className="main__content">
          <a className="footer__item" href="https://www.vinoseleccion.com/tinto-pesquera-crianza-2017?utm_source=Google&utm_medium=Banner&utm_campaign=Tinto+Pesqueta+Crianza&utm_id=123456"><img className="main__image" src={mainImage} alt="Colección Ribera"></img></a>
          <img className="wine__image" src={wineGlass} alt="Colección Ribera"></img>
          <div className="caption__container">
            <div className="caption__item">
              <img className="caption__image" src={captionOne} alt="Vino"></img>
              <div className="caption-text__container">
                <h2 className="caption__title">Envío gratis</h2>
              </div>
            </div>

            <div className="caption__item">
              <img className="caption__image" src={captionTwo} alt="Vino"></img>
              <div className="caption-text__container">
                <h2 className="caption__title">10,00€ de descuento</h2>
              </div>
            </div>

            <div className="caption__item">
              <img className="caption__image" src={captionThree} alt="Vino"></img>
              <div className="caption-text__container">
                <h2 className="caption__title">Sacacorchos de regalo</h2>
              </div>
            </div>
          </div>
        </div>

        <Form></Form>

        <Footer></Footer>

      </div>
    </div>
  );
}

export default App;
